<template>
  <div id="seatsModal" class="modal" :class="{show: show}">
    <NumPadPanel class="seats-num-pad" :title="$t('pos_seats_quantity.title')" icon="icons/seats.svg"
                 :value="seatsQuantity" @update:value="seatsQuantity = $event" @onEnter="setSeatsquantity">
      <div class="seats-num-pad-content">
        <div class="seats__description">{{$t('pos_seats_quantity.description')}}</div>
        <div class="seats__input">
          <label class="input__label">{{$t('pos_seats_quantity.current_nb_seat')}}</label>
          <input type="text" :value="currentSeatsQuantity" readonly disabled>
        </div>
        <div class="seats__input">
          <label class="input__label">{{$t('pos_seats_quantity.new_nb_seat')}}</label>
          <input type="text" :value="seatsQuantity" readonly>
        </div>
      </div>

      <template v-slot:footer>
        <div>
          <button class="btn btn-secondary" @click="back">
            <svgicon src="icons/back-full.svg" :height="25" :width="25"></svgicon>
            {{$t('back')}}
          </button>
        </div>
      </template>
    </NumPadPanel>
  </div>
</template>

<script>
  import NumPadPanel from "@/components/pos/NumPadPanel";
  import EventBus from "@/lib/eventBus";

  export default {
    name: "SeatsModal",

    components: { NumPadPanel },

    data() {
      return {
        seatsQuantity: "",
        show: false
      };
    },

    computed: {
      currentSeatsQuantity() {
        //TODO gotta find where we keep current number of seat or compute it
        return 1;
      }
    },

    mounted() {
      EventBus.$on("show-seats-modal", () => {
        this.show = true;
      });
    },

    beforeDestroy() {
      EventBus.$off("show-seats-modal");
    },

    methods: {
      setSeatsquantity() {
        if (!this.seatsQuantity) {
          return;
        }
        //TODO set seats qty
      },
      back() {
        this.show = false;
        this.seatsQuantity = "";
      }
    }
  };
</script>

<style lang="scss" scoped>

#iShopFoodApp #seatsModal {
  .seats-num-pad-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 380px;
    max-width: 380px;
    height: 100%;
    padding: 30px 20px 30px 40px;
    justify-content: space-around;

    .seats__description {
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 10px;
      align-self: center;
      display: flex;
      justify-content: center;
      align-content: center;
      flex-direction: column;
    }

    .seats__input {
      display: flex;
      flex-direction: column;
      width: 100%;
      .input__label {
        font-size: 18px;
        font-weight: 500;
        color: var(--theme-color-2);
        margin-bottom: 6px;
      }
      input {
        border-radius: 12px;
        border: 1px solid var(--background-color-4);
        padding: 10px 15px;
        font-size: 40px;
        line-height: 1;
        font-weight: 500;
        color: var(--theme-color);
        font-family: inherit;
      }
    }
  }
  .btn {
    font-size: 20px;
    font-weight: 500;
    padding: 15px 25px;
    width: auto;
    line-height: 1;
    font-family: 'Roboto', sans-serif;

    .svgicon {
      margin-right: 15px;
    }
  }
}

</style>